const items = [
  "Aflimart Digital Market",
  "Cross-Border Commerce",
  "African Technology",
  "Global Access",
  "Built in Nigeria",
  "Shop The World From Home",
  "A Marketplace Without Borders",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#E2E8F0] bg-[#F2F4F7] py-5"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-12 whitespace-nowrap">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="font-sans text-lg font-semibold text-[#1E3A8A] sm:text-xl">{t}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#F97316]" />
          </span>
        ))}
      </div>
    </div>
  );
}
